import { createStore } from "vuex";

/**
 * 登录态存储介质说明（2026-10-06 由 sessionStorage 改为 localStorage）
 *
 * sessionStorage 是「页面会话」级存储：微信 web-view 每次重新打开都是一次
 * 全新的页面会话，sessionStorage 随之清空 → 用户每次进小程序都要重新输密码。
 * localStorage 是持久化的，关掉小程序再打开仍然在，符合"登录一次即可"的预期。
 *
 * ⚠️ 改这里必须同时注意 main.js：那段历史遗留的「版本变化 → localStorage.clear()」
 * 逻辑会把登录态一起清掉，导致每次发版把用户踢下线。已在 main.js 里改为放行这些 key。
 */
const USER_KEY = "user";
const STORE_KEY = "store";

const store =  createStore({
  state:{
    loginUser:{

    },
    rate:0.12
  },

  //使用commit
  mutations:{
    SetLoginUser(state, data) {
      localStorage.setItem(USER_KEY, JSON.stringify(data));
      state.loginUser = data;
    },



    removeAll(state, data) {
      localStorage.removeItem(USER_KEY);
      localStorage.removeItem(STORE_KEY);
      state.loginUser={}
    }
  },


  //使用dispatch
  actions:{
    setLoginUser(context, data) {
      context.commit("SetLoginUser", data);
    }
  },

  getters:{

    loginUserName:(state)=>{
      return state.loginUser.userName
    },

    loginUserId:(state)=>{
      return state.loginUser.id
    },

    loginUserRoleId:(state)=>{
      return state.loginUser.roleId
    },

    rate:(state) =>{
      return state.rate
    },
    investment:(state) =>{
      return state.loginUser.investment
    },
    stock:(state) =>{
      return state.loginUser.stock
    },
    name:(state) =>{
      return state.loginUser.name
    },


  }
})

/**
 * 主动把 vuex 状态落到 localStorage。
 *
 * App.vue 里用 `beforeunload` 保存状态，但微信 web-view 被销毁时该事件不保证触发，
 * 会导致「有登录态但 loginUser 为空」→ 首页渲染成空白数字。改成订阅 mutation 即时落盘，
 * 不再依赖页面卸载事件。App.vue 里那段保留即可（两者写入内容一致，不冲突）。
 */
store.subscribe((mutation, state) => {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(state));
  } catch (e) {
    /* 存储不可用时静默降级，不影响业务 */
  }
})

export default store
